// extracted by mini-css-extract-plugin
export default {"container":"loading-planos_container__X-LF0","loading":"loading-planos_loading__n8xz7"};